import { render, staticRenderFns } from "./TFoot.vue?vue&type=template&id=5a4ba07f&scoped=true"
import script from "./TFoot.vue?vue&type=script&lang=js"
export * from "./TFoot.vue?vue&type=script&lang=js"
import style0 from "./TFoot.vue?vue&type=style&index=0&id=5a4ba07f&prod&lang=scss"
import style1 from "./TFoot.vue?vue&type=style&index=1&id=5a4ba07f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4ba07f",
  null
  
)

export default component.exports